import ErrorNotifyController from './error-notification-modal.controller';
import template from './error-notification-modal.html';
import _ from 'lodash'
class ErrorNotificationController {
    constructor($uibModal, $scope) {
        this._$uibModal = $uibModal;

        $scope.$on('showErrorDialog', (event, data) => {
            this.openHelpWindow(data);
        });
    }

    openHelpWindow(data) {
        this.dialogIsShown = true;
        this._$uibModal.open({
            animation: false,
            template: template,
            controllerAs: '$ctrl',
            size: 'md',
            resolve: {
                data: () => {
                    return {
                        type: data.type,
                        text: _.get(data, 'text.error')
                    };
              }
          },
            controller: ErrorNotifyController,
        });
    }
}


ErrorNotificationController.$inject = ['$uibModal', '$scope'];

export default ErrorNotificationController;



// WEBPACK FOOTER //
// ./client/app/common/error-widget/error-widget.controller.js